var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeekOverWeekIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 82,
    viewBox: "0 0 98 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1529 61.2962C11.7333 61.2962 9.76471 59.3241 9.76471 56.9003C9.76471 54.4764 11.7333 52.5043 14.1529 52.5043C16.5724 52.5043 18.541 54.4764 18.541 56.9003C18.541 59.3241 16.5724 61.2962 14.1529 61.2962V61.2962ZM14.1529 53.8329C12.4644 53.8329 11.0909 55.2088 11.0909 56.9003C11.0909 58.5917 12.4644 59.9676 14.1529 59.9676C15.8413 59.9676 17.2148 58.5917 17.2148 56.9003C17.2148 55.2088 15.8413 53.8329 14.1529 53.8329Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3843 35.1214C34.9647 35.1214 32.9961 33.1493 32.9961 30.7255C32.9961 28.3016 34.9647 26.3295 37.3843 26.3295C39.8038 26.3295 41.7725 28.3016 41.7725 30.7255C41.7725 33.1493 39.8038 35.1214 37.3843 35.1214ZM37.3843 27.6581C35.6958 27.6581 34.3224 29.034 34.3224 30.7255C34.3224 32.4169 35.6958 33.7928 37.3843 33.7928C39.0727 33.7928 40.4462 32.4169 40.4462 30.7255C40.4462 29.034 39.0727 27.6581 37.3843 27.6581Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6157 50.8793C58.1962 50.8793 56.2275 48.9072 56.2275 46.4833C56.2275 44.0595 58.1962 42.0874 60.6157 42.0874C63.0352 42.0874 65.0039 44.0595 65.0039 46.4833C65.0039 48.9072 63.0352 50.8793 60.6157 50.8793ZM60.6157 43.416C58.9272 43.416 57.5538 44.7919 57.5538 46.4833C57.5538 48.1748 58.9272 49.5507 60.6157 49.5507C62.3042 49.5507 63.6776 48.1748 63.6776 46.4833C63.6776 44.7919 62.3042 43.416 60.6157 43.416V43.416Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8479 19.3644C81.4284 19.3644 79.4598 17.3923 79.4598 14.9684C79.4598 12.5446 81.4284 10.5725 83.8479 10.5725C86.2675 10.5725 88.2361 12.5446 88.2361 14.9684C88.2361 17.3923 86.2675 19.3644 83.8479 19.3644ZM83.8479 11.9011C82.1595 11.9011 80.786 13.277 80.786 14.9684C80.786 16.6599 82.1595 18.0358 83.8479 18.0358C85.5364 18.0358 86.9099 16.6599 86.9099 14.9684C86.9099 13.277 85.5364 11.9011 83.8479 11.9011Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4132 33.0724L16.1314 53.6714L17.1225 54.5541L35.4044 33.9552L34.4132 33.0724Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8408 32.2698L40.0973 33.3699L57.1599 44.9427L57.9034 43.8426L40.8408 32.2698Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0983 17.5685L62.2936 43.0826L63.3605 43.8717L82.1652 18.3577L81.0983 17.5685Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8441 81H8.46088V68.4141C8.46088 67.8453 8.9234 67.382 9.49119 67.382H18.8138C19.3816 67.382 19.8441 67.8453 19.8441 68.4141V81ZM9.78711 79.6714H18.5178V68.7106H9.78711V79.6714Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0763 81H31.6931V50.5828C31.6931 50.014 32.1556 49.5507 32.7234 49.5507H42.046C42.6138 49.5507 43.0763 50.014 43.0763 50.5828V81V81ZM33.0193 79.6714H41.7501V50.8793H33.0193V79.6714Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3077 81H54.9245V60.9998C54.9245 60.431 55.3871 59.9677 55.9548 59.9677H65.2774C65.8452 59.9677 66.3077 60.431 66.3077 60.9998V81V81ZM56.2508 79.6714H64.9815V61.2962H56.2508V79.6714Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5391 81H78.1559V34.825C78.1559 34.2562 78.6185 33.7928 79.1863 33.7928H88.5088C89.0766 33.7928 89.5391 34.2562 89.5391 34.825V81ZM79.4822 79.6714H88.2129V35.1214H79.4822V79.6714Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3369 81H1.66312C1.29674 81 1 80.7027 1 80.3357C1 79.9687 1.29674 79.6714 1.66312 79.6714H96.3369C96.7033 79.6714 97 79.9687 97 80.3357C97 80.7027 96.7033 81 96.3369 81Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7286 7.8007C83.5529 7.8007 83.3838 7.73095 83.2594 7.6064L80.1718 4.51328C79.9132 4.25421 79.9132 3.83321 80.1718 3.57414C80.4312 3.31506 80.8507 3.31506 81.1093 3.57414L83.7278 6.19809L88.7227 1.19431C88.9821 0.935231 89.4015 0.935231 89.6601 1.19431C89.9188 1.45338 89.9188 1.87438 89.6601 2.13345L84.1961 7.60723C84.0717 7.73178 83.9027 7.80153 83.7269 7.80153L83.7286 7.8007Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4403 10.5334H8.46832C8.10195 10.5334 7.80521 10.2362 7.80521 9.86914C7.80521 9.50212 8.10195 9.20485 8.46832 9.20485H31.4403C31.8067 9.20485 32.1034 9.50212 32.1034 9.86914C32.1034 10.2362 31.8067 10.5334 31.4403 10.5334Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4403 17.4404H16.7805C16.4141 17.4404 16.1173 17.1432 16.1173 16.7761C16.1173 16.4091 16.4141 16.1118 16.7805 16.1118H31.4403C31.8066 16.1118 32.1034 16.4091 32.1034 16.7761C32.1034 17.1432 31.8066 17.4404 31.4403 17.4404Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0152 24.3474H8.46832C8.10195 24.3474 7.80521 24.0501 7.80521 23.6831C7.80521 23.3161 8.10195 23.0188 8.46832 23.0188H26.0152C26.3815 23.0188 26.6783 23.3161 26.6783 23.6831C26.6783 24.0501 26.3815 24.3474 26.0152 24.3474V24.3474Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1001 33.5578C59.912 33.5578 59.7329 33.4781 59.6069 33.3378L58.0677 31.6247C57.7809 31.3051 57.3698 31.1224 56.9412 31.1224H51.2484C49.5251 31.1224 48.1234 29.7182 48.1234 27.9919V15.0075C48.1234 13.2811 49.5251 11.877 51.2484 11.877H64.388C66.1113 11.877 67.5129 13.2811 67.5129 15.0075V27.9919C67.5129 29.7182 66.1113 31.1224 64.388 31.1224H63.259C62.8297 31.1224 62.4194 31.3059 62.1326 31.6247L60.5933 33.3378C60.4673 33.4781 60.2883 33.5578 60.1001 33.5578V33.5578ZM51.2484 13.2056C50.2562 13.2056 49.4497 14.0135 49.4497 15.0075V27.9919C49.4497 28.9858 50.257 29.7938 51.2484 29.7938H56.9412C57.7452 29.7938 58.5153 30.1376 59.0532 30.7363L60.1001 31.9013L61.147 30.7363C61.685 30.1376 62.455 29.7938 63.259 29.7938H64.388C65.3802 29.7938 66.1867 28.9858 66.1867 27.9919V15.0075C66.1867 14.0135 65.3794 13.2056 64.388 13.2056H51.2484V13.2056Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.043 19.415H53.5925C53.2261 19.415 52.9294 19.1178 52.9294 18.7507C52.9294 18.3837 53.2261 18.0865 53.5925 18.0865H62.043C62.4094 18.0865 62.7062 18.3837 62.7062 18.7507C62.7062 19.1178 62.4094 19.415 62.043 19.415Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1623 25.0267H53.5925C53.2261 25.0267 52.9294 24.7294 52.9294 24.3624C52.9294 23.9953 53.2261 23.6981 53.5925 23.6981H60.1623C60.5287 23.6981 60.8254 23.9953 60.8254 24.3624C60.8254 24.7294 60.5287 25.0267 60.1623 25.0267Z",
    fill: "#003F88",
    stroke: "#003F88",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekOverWeekIcon);
export default __webpack_public_path__ + "static/media/week-over-week-icon.de6f9c90a58c5320a7e6150aa454d1af.svg";
export { ForwardRef as ReactComponent };